export default __webpack_public_path__ + "static/media/container.ecd9f0cc.png";